import {useMemo} from 'react'

import {checkFeatureFlag} from '../helpers'
import {ConfigurationName, FeatureFlagParams, AllowedKeys} from '../types'

import {useFeatureFlagsQuery} from './queries'

type Exact<T, Shape extends T> = T & {
  [K in keyof Shape]: K extends keyof T ? Shape[K] : never
}

export function useFeatureFlag<C extends ConfigurationName, K extends AllowedKeys<C>>(
  configurationName: C,
  key: K,
  params?: Exact<FeatureFlagParams[K], FeatureFlagParams[K]>
): boolean | undefined {
  const {data: featureFlags} = useFeatureFlagsQuery({
    configurationName,
    params: params as Record<string, string | number | boolean | string[] | undefined>
  })

  return useMemo(
    () => (featureFlags === undefined ? undefined : checkFeatureFlag(featureFlags, key)),
    [featureFlags, key]
  )
}
